/**
 * Montagem de células de CSV para os relatórios baixados no painel.
 *
 * Além de aspas, vírgula e quebra de linha, neutraliza fórmula: Excel,
 * LibreOffice e Google Sheets executam a célula que começa com `=`, `+`, `-`,
 * `@`, tabulação ou retorno de carro. Como nome e e-mail vêm do cadastro do
 * participante, um valor como `=HYPERLINK(...)` viraria fórmula ativa na
 * máquina de quem abre o relatório. O apóstrofo à frente faz a planilha tratar
 * o conteúdo como texto.
 */
const INICIO_DE_FORMULA = /^[=+\-@\t\r]/;

export const csvCell = (value) => {
  const text = String(value ?? '');
  const seguro = INICIO_DE_FORMULA.test(text) ? `'${text}` : text;
  return /[",\n]/.test(seguro) ? `"${seguro.replace(/"/g, '""')}"` : seguro;
};

export const csvRow = (values = []) => values.map(csvCell).join(',');
